/**
 * Radix modal surfaces (Dialog, Sheet) dismiss on any outside pointer/focus
 * interaction. The copilot sidebar lives outside those portals, so clicking
 * into the chat would close the very detail dialog the user is asking about —
 * wiping the open-entity ambient context before the message is even sent.
 *
 * Pass this to `onInteractOutside` on any detail surface that reports itself
 * via `useSetOpenEntity`, so copilot-owned surfaces never trigger dismissal.
 */

/** Matches every CopilotKit-rendered surface: sidebar, chat, launcher button. */
const COPILOT_SURFACE_SELECTOR = "[data-copilotkit]";

interface RadixOutsideEvent {
  detail: { originalEvent: Event };
  preventDefault: () => void;
}

export function ignoreCopilotInteractOutside(event: RadixOutsideEvent) {
  // The event's own target is the dialog content; the element the user actually
  // touched is only on the wrapped original event.
  const target = event.detail?.originalEvent?.target;
  if (target instanceof Element && target.closest(COPILOT_SURFACE_SELECTOR)) {
    event.preventDefault();
  }
}
